module.exports = __webpack_public_path__ + "media/backgrounds/thilak-mohan-USK5WvXLrX4-unsplash-e27af3b6.jpg";